import { Transition } from '@studiometa/ui';
import { untrapFocus, trapFocus } from '@studiometa/js-toolkit/utils';

/**
 * Panel component
 */
export default class Panel extends Transition {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Panel',
    refs: ['close[]'],
    options: {
      open: Boolean,
    },
  };

  /**
   * get isOpen
   * @returns {boolean}
   */
  get isOpen() {
    return this.$options.open;
  }

  /**
   * set isOpen
   */
  set isOpen(value) {
    this.$options.open = value;
  }

  /**
   * mounted
   */
  mounted() {
    if (this.isOpen) {
      this.open();
    } else {
      this.$el.setAttribute('aria-hidden', 'true');
      this.$el.setAttribute('inert', '');
    }
  }

  /**
   * Focus trap when Cart is open
   * @param {boolean} ESC Will be true if the key initiating the event is the esc key.
   */
  keyed({ event, isDown, isUp, ESC }) {
    if (!this.isOpen) {
      return;
    }

    if (isDown) {
      trapFocus(document.body, event);
    }

    if (ESC && isUp) {
      this.close();
    }
  }

  /**
   * onCloseClick
   */
  onCloseClick() {
    this.close();
  }

  /**
   * open fn
   */
  open() {
    this.keyupHandler = (event) => {
      trapFocus(this.$el, event);
    };
    document.addEventListener('keyup', this.keyupHandler);
    this.isOpen = true;
    this.enter();
    document.body.style.overflow = 'hidden';
    this.$el.setAttribute('aria-hidden', 'false');
    this.$el.removeAttribute('inert');
  }

  /**
   * close fn
   */
  close() {
    if (this.keyupHandler) {
      document.removeEventListener('keyup', this.keyupHandler);
      this.keyupHandler = null;
    }
    untrapFocus();
    this.isOpen = false;
    this.leave();
    document.body.style.overflow = '';
    this.$el.setAttribute('aria-hidden', 'true');
    this.$el.setAttribute('inert', '');
  }
}
